var _path, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffRampIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 58,
    viewBox: "0 0 47 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0218 47.1841C31.756 47.1841 38.8365 40.1036 38.8365 31.3694C38.8365 22.6352 31.756 15.5547 23.0218 15.5547C14.2875 15.5547 7.20703 22.6352 7.20703 31.3694C7.20703 40.1036 14.2875 47.1841 23.0218 47.1841Z",
    fill: "#FDD835"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2328_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0184 50.3884C33.522 50.3884 42.0369 41.8736 42.0369 31.37C42.0369 20.8664 33.522 12.3516 23.0184 12.3516C12.5148 12.3516 4 20.8664 4 31.37C4 41.8736 12.5148 50.3884 23.0184 50.3884Z",
    fill: "url(#paint0_linear_2328_4567)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2328_4567)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2328_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0205 44.9683C30.5309 44.9683 36.6192 38.88 36.6192 31.3697C36.6192 23.8593 30.5309 17.771 23.0205 17.771C15.5102 17.771 9.42188 23.8593 9.42188 31.3697C9.42188 38.88 15.5102 44.9683 23.0205 44.9683Z",
    fill: "url(#paint1_linear_2328_4567)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2328_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8116 30.7777C26.8416 30.7619 26.8716 30.7462 26.9 30.7288C27.2048 30.5022 27.4554 30.2106 27.6334 29.875C27.8114 29.5394 27.9124 29.1684 27.929 28.7889C27.9457 28.4094 27.8775 28.031 27.7295 27.6811C27.5815 27.3313 27.3574 27.0188 27.0735 26.7665C26.6154 26.4545 26.1025 26.2318 25.5618 26.11L24.3783 25.9128V23.4795H23.0639V25.8465H21.8804V23.4795H20.4333V25.8465H17.5409V27.3582H18.6581C18.8542 27.3939 19.0301 27.5012 19.1517 27.6592C19.2733 27.8172 19.3319 28.0147 19.3161 28.2135C19.3161 30.2523 19.2498 32.3557 19.2498 34.3945C19.2498 34.8537 19.0526 35.0509 18.5918 35.0509H17.6056C17.5282 35.6268 17.4186 36.1979 17.2773 36.7615C18.2636 36.7615 19.1836 36.7615 20.1698 36.8262V39.2595H21.7478V36.8262C22.1435 36.8152 22.5393 36.8374 22.9313 36.8925V39.2595H24.3783V36.8262H24.5093C25.1673 36.6952 25.8901 36.6289 26.5481 36.498C26.9726 36.4158 27.3696 36.2282 27.7027 35.9524C28.0358 35.6767 28.2942 35.3217 28.4543 34.92C28.7393 34.2579 28.8307 33.5285 28.7178 32.8165C28.6913 32.4856 28.5807 32.167 28.3965 31.8908C28.2123 31.6146 27.9606 31.3901 27.6653 31.2385C27.4475 31.1296 27.1919 31.0207 26.9142 30.9103L26.8021 30.8661L26.7611 30.8535L26.7169 30.8393L26.769 30.8061L26.8116 30.7777ZM21.8804 27.5555C22.7492 27.4614 23.6279 27.5744 24.4446 27.8853C24.6882 27.9821 24.8952 28.1531 25.0363 28.3741C25.1773 28.595 25.2454 28.8547 25.2307 29.1165C25.216 29.3782 25.1194 29.6287 24.9546 29.8326C24.7897 30.0364 24.5649 30.1832 24.3121 30.2523C23.5006 30.4823 22.6516 30.5493 21.8141 30.4495C21.8804 29.4633 21.8804 28.5417 21.8804 27.5555ZM25.0364 34.7227C24.2294 34.9863 23.3857 35.1194 22.5368 35.1172H21.8141C21.8141 34.0647 21.8141 33.0138 21.8804 31.895C22.9698 31.7947 24.068 31.9293 25.1011 32.2895C25.3523 32.3883 25.5681 32.5602 25.7206 32.783C25.8731 33.0058 25.9552 33.2692 25.9563 33.5392C25.9496 33.8089 25.8566 34.0693 25.691 34.2823C25.5255 34.4953 25.296 34.6496 25.0364 34.7227Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2328_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7646 10.8655L26.2852 10.8971L29.8373 6.29994L34.7053 0L43.2741 10.7814L38.8199 10.8128L38.2039 10.8169V26.7909H30.9476V10.8643L30.7646 10.8655Z",
    fill: "url(#paint2_linear_2328_4567)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2328_4567",
    x: 0.349325,
    y: 12.3516,
    width: 45.3365,
    height: 45.338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4567",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2328_4567",
    x: 6.62745,
    y: 15.4065,
    width: 32.7881,
    height: 32.7861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.429912
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2328_4567",
    x: 5.7712,
    y: 17.771,
    width: 34.5006,
    height: 34.4986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4567",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2328_4567",
    x: 16.6355,
    y: 22.8377,
    width: 12.7719,
    height: 17.0634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.320904
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2328_4567",
    x: 22.6345,
    y: 0,
    width: 24.2896,
    height: 34.0924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4567",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2328_4567",
    x1: 33.9112,
    y1: 13.3506,
    x2: -6.19152,
    y2: 31.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2328_4567",
    x1: 30.8091,
    y1: 18.4853,
    x2: 2.13468,
    y2: 31.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2328_4567",
    x1: 39.6448,
    y1: 0.703669,
    x2: 19.6199,
    y2: 6.5827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffRampIcon);
export default __webpack_public_path__ + "static/media/offRampIcon.58dea926463f3cefda55abbc6828e032.svg";
export { ForwardRef as ReactComponent };